import type { IconProps } from './types';

export const AddCommentIcon = (props: IconProps) => {
  const {
    size = 20,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M6.32892 17.5097C7.43704 18.0524 8.68294 18.3571 10 18.3571C14.6156 18.3571 18.3571 14.6156 18.3571 10C18.3571 5.38448 14.6156 1.64286 10 1.64286C5.38447 1.64286 1.64285 5.38448 1.64285 10C1.64285 11.7134 2.15845 13.3063 3.04294 14.632M6.32892 17.5097L1.64285 18.3571L3.04294 14.632M6.32892 17.5097L6.33571 17.5086M3.04294 14.632L3.04428 14.6286"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.45906V13.5305"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.46429 9.99422H13.5357"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
